<h2 mat-dialog-title>{{title}}</h2>

<div mat-dialog-content>

    <div fxLayout="row stretch" fxLayout.xs="column">
        <div [innerHTML]="message"></div>
    </div>

</div>

<br/>

<div mat-dialog-actions>
    <div fxLayout="row stretch" fxLayout.xs="column">
        <button mat-raised-button color="primary" (click)="onAccept()" class="zb-button" *ngIf="showButtonAcceptText">{{buttonAcceptText}}</button>
        <button mat-raised-button color="warn" (click)="onDecline()" class="zb-button" *ngIf="showButtonCancelText">{{buttonCancelText}}</button>
    </div>
</div>